var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper page-company"},[_c('Header'),_c('div',{staticClass:"page-wrapper"},[_c('CompanyLineWorksForm'),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }